<div class="item" *ngFor="let item of items | slice: start:end" [attr.data-cy]="generateDataCyId('-item-container')">
  <ng-container *ngTemplateOutlet="template; context: { item: item }"> </ng-container>
</div>
